// extracted by mini-css-extract-plugin
export default {"checkout":"CheckoutDetails_checkout__HA4BB","card":"CheckoutDetails_card__VIVGh","card-details":"CheckoutDetails_card-details__usOEv"};